import { FC } from 'react';

/** @deprecated */
const DownloadIcon: FC = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="4.91696"
      height="0.983392"
      transform="matrix(-0.69496 -0.719049 0.69496 -0.719049 3.42676 7.99179)"
      fill="#0088EC"
    />
    <rect
      width="4.91696"
      height="0.983392"
      transform="matrix(0.69496 -0.719049 -0.69496 -0.719049 3.59277 7.99179)"
      fill="#0088EC"
    />
    <rect
      x="3.00977"
      y="6.74915"
      width="6"
      height="1"
      transform="rotate(-90 3.00977 6.74915)"
      fill="#0088EC"
    />
  </svg>
);

export default DownloadIcon;
